import Highway from '@dogstudio/highway'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

import Lenis from '@studio-freight/lenis'

import { evt, utils, store } from '@/core'

const { dom, flags, device } = store
const { qs, qsa } = utils

import {
    scrollAnim,
    circleText,
    swiper3Cards,
    Menu,
} from '@/components'

import { lenis } from '../app'

export default class extends Highway.Renderer {
    setup() {
        this.onEnter()

        device.isMobile && dom.body.classList.add('is-mobile')

        window.onload = () => this.load()
    }

    onEnter() {
        this.el = this.wrap.lastElementChild

        window.scrollTo(0,0)
        document.querySelector('.header').classList.remove('up')

        this.handleActive()
//        lenis.scrollTo(0)
        lenis.start()
        
        Menu()
    }

    onEnterCompleted() {
        lenis.start()

        let hClientsList = qs('.list-nav-clients').clientHeight + 60
        qs('.portal-clientes').style = "--hAfter:"+hClientsList+'px'

        lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
            evt.emit('scroll', {
                scrollY: scroll,
                velocity,
                direction
            })
        })

        
        function validarEmail(email) {
            const regex = /^[a-zA-Z0-9](\.?[a-zA-Z0-9_-])*@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
            return regex.test(email);
        }

        const inputsEmail = qsa(".hero-form input[type=email]"); 
        inputsEmail.forEach( input => {
            input.addEventListener("keyup", function() {
                const email = input.value;
                const buttonSend = input.closest('.hero-form').querySelector('button')
                if (validarEmail(email)) {
                    console.log("Correo electrónico válido");
                    input.style.borderColor = "#707070"; 
                    buttonSend.style.pointerEvents = 'initial'
                } else {
                    console.log("Correo electrónico no válido");
                    input.style.borderColor = "red"; 
                    buttonSend.style.pointerEvents = 'none'
                }
            });
        })
        

        let header = qs('.header')
        evt.on('scroll', (e)=>{
            //header
            if( e.direction == 1){
                console.log('entra up')
                header.classList.add('up')
            }else if( e.direction == -1){
                console.log('sale up')
                header.classList.remove('up')
    
            }
        })

        qsa(".scrollButton").forEach(button => {
            button.addEventListener("click", () => {
                lenis.scrollTo(window.innerHeight)
            })
        })

        function raf(time) {
            lenis.raf(time)
            requestAnimationFrame(raf)
        }
        
        requestAnimationFrame(raf)
        
        
        this.primaryButton();

        swiper3Cards(this.el)


        qsa(".js-anchor-link").forEach(b => {
            b.addEventListener("click", (e) => {
                e.preventDefault();
                
                lenis.scrollTo(b.dataset.href)
            })
        })

		qsa(".js-anchor-legales").forEach(b => {
            b.addEventListener("click", (e) => {
				console.log('ale')
                e.preventDefault();
                qsa(".js-anchor-legales").forEach(b=>b.classList.remove('active'))
                b.classList.add('active')
                lenis.scrollTo(b.dataset.rel)
            })
        })
        
        const origin = window.location.origin;

        let data = []; 
        let selectedAreaCode = ''; 

        async function loadData() {
            try {
                const response = await fetch(origin+'/wp-content/themes/lifetheme/assets/data/codigos-area.json'); // Asegúrate de que la ruta sea correcta
                if (!response.ok) {
                    throw new Error('Error al cargar el archivo JSON');
                }
                data = await response.json();
                console.log("Datos cargados:", data);

                setupInputEvent(); // Agregar evento de input después de cargar los datos
            } catch (error) {
                console.error(error);
            }
        }

        const containerCelular = document.querySelector('.container-celular');
        const resultDiv = document.createElement('div');
        resultDiv.id = 'result';
        resultDiv.classList.add('suggestions');
        containerCelular &&
        containerCelular.appendChild(resultDiv)
        
        function setupInputEvent() {
            document.querySelector('.cod') &&
            document.querySelector('.cod').addEventListener('input', function () {
                const codeValue = this.value;
                const resultDiv = document.getElementById('result');
                resultDiv.innerHTML = ''; 

                if (codeValue === '') {
                    resultDiv.style.display = 'none';
                    selectedAreaCode = ''; 
                    document.querySelector('.phone').value = '';
                    document.querySelector('.phone').maxLength = 10;
                    return;
                } else {
                    resultDiv.style.display = 'block';
                }

                const matches = data.filter(item => item["CODIGO AREA"].startsWith(codeValue));
               // const isValidAreaCode = matches.some(item => item["CODIGO AREA"] === codeValue);
                if (!matches) {
                    resultDiv.innerHTML = '<p>El código de área ingresado no es válido.</p>';
                    return;
                }

                if (matches.length > 0) {
                    const resultsToShow = matches.length < 5 ? matches : matches.slice(0, -1);
                    resultsToShow.forEach(match => {
                        const resultItem = document.createElement('div');
                        resultItem.innerHTML = `<p style="color: #2f347e;">${match["CODIGO AREA"]}, ${match.PROVINCIA}, ${match.LOCALIDAD}</p>`;
                        resultItem.classList.add('result-item');
                        resultItem.dataset.codigoArea = match["CODIGO AREA"];
                        resultDiv.appendChild(resultItem);
                    });
                } else {
                    if (codeValue) {
                        resultDiv.innerHTML = '<p>No se encontraron resultados para el código ingresado.</p>';
                    }
                }
            });
        }

        document.getElementById('result') &&
        document.getElementById('result').addEventListener('click', function (event) {
            if (event.target.closest('.result-item')) {
                selectedAreaCode = event.target.closest('.result-item').dataset.codigoArea;
                document.querySelector('.cod').value = selectedAreaCode;
                
                this.innerHTML = '';
                this.style.display = 'none';

                let maxLength;
                switch (selectedAreaCode.length) {
                    case 3:
                        maxLength = 8;
                        break;
                    case 4:
                        maxLength = 7;
                        break;
                    case 5:
                        maxLength = 6;
                        break;
                    default:
                        maxLength = 10;
                }

                const phoneInput = document.querySelector('.phone');
                phoneInput.maxLength = maxLength;
                phoneInput.value = '';
            }
        });
        document.querySelector('.phone') &&
        document.querySelector('.phone').addEventListener('input', function () {
            let maxLength = this.maxLength;
            const inputValue = this.value;

            if (inputValue.startsWith('11') || inputValue.startsWith('15')) {
                maxLength += 2;
            }

            if (inputValue.length > maxLength) {
                this.value = inputValue.slice(0, maxLength);
            }
        });

        qsa('.hero-form form').forEach( f => {
            f.addEventListener("submit", (event) => {
                event.preventDefault();
                const errorMessage = document.getElementById('errorMessage');
                errorMessage.style.display = 'none';

                const numberInput = f.querySelector('.phone') && f.querySelector('.phone').value.trim();
                const expectedLength = f.querySelector('.phone') && f.querySelector('.phone').maxLength;

                if(numberInput && expectedLength){
                
                    if (selectedAreaCode === '' || numberInput === '' || numberInput.length !== expectedLength) {
                        errorMessage.style.display = 'block';
                        errorMessage.textContent = selectedAreaCode === '' || numberInput === ''
                            ? "Por favor, completa ambos campos."
                            : `Por favor ingrese un número de teléfono válido de ${expectedLength} dígitos.`;
                        return;
                    }

                }

                const hasRepeatedDigits = /(\d)\1{4}/.test(numberInput);
                const hasConsecutiveSequence = /(01234|12345|23456|34567|45678|56789|67890|98765|87654|76543|65432|54321|43210)/.test(numberInput);

                if (hasRepeatedDigits) {
                    errorMessage.style.display = 'block';
                    errorMessage.textContent = "El número no puede contener 5 dígitos iguales consecutivos.";
                    return;
                }

                if (hasConsecutiveSequence) {
                    errorMessage.style.display = 'block';
                    errorMessage.textContent = "El número no puede contener secuencias de 5 dígitos consecutivos.";
                    return;
                }

                errorMessage.style.display = 'none';
                errorMessage.textContent = "";

                console.log("Código de área:", selectedAreaCode);
                console.log("Número:", numberInput);
                
                // if(numberInput && expectedLength){
                //     f.querySelector('.cod').value = '';
                //     f.querySelector('.phone').value = '';
                // }
                // selectedAreaCode = '';
                if(document.getElementById('result') )
                document.getElementById('result').style.display = 'none';
                //f.submit()
                f.classList.add('sending')
                //f.querySelector('.primary-button').style.visibility = 'hidden'
                f.submit()
            });
        })

        loadData();
        
    }

    onLeave() {
        lenis.stop()
//        lenis.scrollTo(0)
        lenis.start()

        if(qs('.burger').classList.contains('open')){
            qs('.burger').dispatchEvent(new Event('click'))
        }
    }

    onLeaveCompleted() {
        lenis.start()
        ScrollTrigger.getAll().forEach(inst => inst.kill())
    }

    load() {
        this.onEnterCompleted()
//        lenis.scrollTo(0)
        lenis.start()
        // gsap.to(dom.mask, {
        //     autoAlpha: 0,
        //     duration: .75,
        //     ease: 'power1'
        // })

        evt.emit('first')
    }

    /** Init components **/

    /** Handle misc **/

    handleActive() {
        qsa('.js-site-link').forEach(el => {
            el.href === location.href
                ? el.classList.add('is-active')
                : el.classList.remove('is-active')
        })
    }
    primaryButton(){
        let primaryButton = qsa('.primary-button')
        primaryButton && primaryButton.forEach( pb => pb.style = `--w:${pb.offsetWidth - 20}px`)
    }
}